import { useState } from "react";
import isEqual from "lodash/isEqual";
const getInitialColumnWidthPreferences = (layoutPreferences) => {
  var _a;
  return Object.fromEntries(
    Object.entries((_a = layoutPreferences == null ? void 0 : layoutPreferences.attributes) != null ? _a : {}).flatMap(
      ([key, { width }]) => typeof width === "number" ? [[key, width]] : []
    )
  );
};
const useInternalLayoutPreferences = ({
  layoutPreferences,
  defaultColumnOrder
}) => {
  const getInitialState = () => {
    var _a;
    return {
      internalAttributeColumnOrder: (_a = layoutPreferences == null ? void 0 : layoutPreferences.order) != null ? _a : defaultColumnOrder,
      internalColumnWidthPreferences: getInitialColumnWidthPreferences(layoutPreferences)
    };
  };
  const [prevInitialState, setPrevInitialState] = useState(getInitialState);
  const [internalAttributeColumnOrder, setInternalAttributeColumnOrder] = useState(
    () => prevInitialState.internalAttributeColumnOrder
  );
  const [internalColumnWidthPreferences, setInternalColumnWidthPreferences] = useState(
    () => prevInitialState.internalColumnWidthPreferences
  );
  const nextInitialState = getInitialState();
  if (!isEqual(nextInitialState, prevInitialState)) {
    setPrevInitialState(nextInitialState);
    setInternalAttributeColumnOrder(nextInitialState.internalAttributeColumnOrder);
    setInternalColumnWidthPreferences(nextInitialState.internalColumnWidthPreferences);
  }
  return {
    internalAttributeColumnOrder,
    setInternalAttributeColumnOrder,
    internalColumnWidthPreferences,
    setInternalColumnWidthPreferences
  };
};
export default useInternalLayoutPreferences;
